import React, { useRef, useCallback, useState, useEffect } from 'react';
import { Loader } from 'components/Loader';
import { ButtonLabel } from 'components/Button';
import { RentCard } from './RentCard';
import PropTypes from 'prop-types';
import { usePageVisibility } from 'hooks/useVisibility';

import 'rc-dropdown/assets/index.css';


const RentColumn = ({ item, rentList, limit, button, userOption, onScrollColumn, stock }) => {
  const [_, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const observer = useRef();
  const isVisible = usePageVisibility();

  useEffect(() => {
    if (isVisible && stock) {
      setHasMore(true);
      setOffset(0);
    }
  }, [isVisible, stock]);

  const lastRentElementRef = useCallback(
    (node) => {
      if (!rentList || rentList.length % limit || !hasMore) {
        return;
      }
      if (observer.current) {
        observer.current.disconnect();
      }
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setOffset((state) => {
            const result = state + limit;
            onScrollColumn({ sub_queries: item.query, offset: result }).then((data) => {
              setHasMore(data.length === limit);
            });
            return result;
          });
        }
      });
      if (node) {
        observer.current.observe(node);
      }
    },
    [userOption, rentList]
  );

  return (
    <>
      <div className="column" key={item.status}>
        <div className="column-meta">
          <ButtonLabel className={item.classColor} text={item.status} />
          {button}
        </div>

        <div className="column-content scrollable">
          {rentList &&
            rentList.map((rent, index) => {
              const cardRef = rentList.length === index + 1 ? lastRentElementRef : null;
              return (
                <div key={rent.actID1C} ref={cardRef}>
                  <RentCard
                    key={rent.actID1C}
                    user={rent.clientID}
                    rentId={rent.actID1C}
                    rentTerm={rent.endDateTime}
                    instruments={rent.chosenItem}
                    comment={rent.comment}
                    userOption={userOption}
                  />
                </div>
              );
            })}

          {rentList == null && <Loader type="small" color="#000" />}
        </div>
      </div>
    </>
  );
};

RentColumn.propTypes = {
  item: PropTypes.shape({
    query: PropTypes.string,
    status: PropTypes.string,
    classColor: PropTypes.string,
  }),
  stock: PropTypes.any,
  rentList: PropTypes.any,
  limit: PropTypes.number,
  button: PropTypes.node,
  userOption: PropTypes.any,
  onScrollColumn: PropTypes.func.isRequired,
};

export { RentColumn };
